import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, ScrollView } from 'react-native';
import { DataStore } from 'aws-amplify';
import { Farm, AppUser, UserType } from '../../models';
import * as AppConst from '../../components/AppConst';
import * as DataStoreUtil from '../../components/DataStoreUtil';
import * as CmnUtil from '../../components/CmnUtil';
import IconImages from '../../components/IconImages';

/** ================================
*  ユーザー詳細画面
*  ================================*/
const UserDetail = ({ closeFunction, userId }: { closeFunction: Function, userId: string }) => {

  const [userInfo, setUserInfo] = useState<AppUser | undefined>(undefined);
  const [farmList, setFarmList] = useState<Farm[]>([]);

  useEffect(() => {
    (async () => {
      // ユーザー情報取得
      const appUser = (await DataStore.query(AppUser, userId));
      if (appUser == undefined) {
        setUserInfo(undefined);
        setFarmList([]);
        return;
      }
      setUserInfo(appUser);

      // 圃場情報取得
      const farms = (await DataStore.query(Farm)).filter(c => c.user.id === userId);
      setFarmList([...farms]);

    })();
  }, []);

  return (
    <View style={AppConst.styles.dialog}>
      <View style={AppConst.styles.dialogContents}>
        <View style={{ backgroundColor: AppConst.defaultBaseColor, width: 450, borderRadius: 10 }}>
          <AppConst.DialogHeader closeFunction={closeFunction} />

          <ScrollView style={{ maxHeight: 450, paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }}>

            <Text style={styles.title}>ユーザー</Text>
            {userInfo && <View style={{ backgroundColor: AppConst.defaultBaseInputColor, borderRadius: 10 }}>
              <View style={{ flexDirection: 'row' }}>
                <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                  <CmnUtil.S3Image imageKey={userInfo.icon} style={styles.userIcon} defaultSource={IconImages.ic_user} />
                </View>
                <View style={{ paddingLeft: 10, width: '100%' }}>
                  <View >
                    <Text>[{DataStoreUtil.convUserType(userInfo.type)}]</Text>
                  </View>
                  <Text>{userInfo.username}</Text>
                  <Text>{userInfo.authUserID}</Text>
                  <Text>{userInfo.profile}</Text>
                </View>
              </View>
              <View style={{ alignItems: 'flex-end' }}>
                <Text style={{ color: '#aaaaaa' }}>{userInfo.id}</Text>
              </View>
            </View>}

            {userInfo?.type == UserType.PRODUCER && <View>
              <Text style={styles.title}>圃場</Text>
              {farmList.map((data: Farm, index: number) => (
                <View key={index} style={{ backgroundColor: AppConst.defaultBaseInputColor, borderRadius: 10, marginTop: 5, marginBottom: 5 }}>
                  <View style={{ paddingLeft: 10, width: '100%' }}>
                    <Text>{data.name}</Text>
                    <Text>{data.memo}</Text>
                  </View>
                  <View style={{ alignItems: 'flex-end' }}>
                    <Text style={{ color: '#aaaaaa' }}>{data.id}</Text>
                  </View>
                </View>
              ))}
              {farmList.length == 0 && <View>
                <Text>圃場はありません</Text>
              </View>}
            </View>}

          </ScrollView>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  title: {
    marginTop: 10,
  },
  userIcon: {
    width: 50,
    height: 50,
    borderRadius: 25,
  },
});

export default UserDetail;
